import i18n from '@/core/i18n';
import { BaseStatus, StatusConfig } from '@/modules/common';
import { createStatusOptionsMapper } from '@/modules/common/mappers/status-options.mapper';
import { TimeOffStatus } from '@/modules/time-off/types/time-off-status';

export class TimeOffStatusApproved implements BaseStatus {
  getConfig(): StatusConfig {
    return {
      colorClasses: 'border border-emerald-500 text-emerald-500',
    };
  }
}

export class TimeOffStatusPending implements BaseStatus {
  getConfig(): StatusConfig {
    return {
      colorClasses: 'border border-slate-500 text-slate-500',
    };
  }
}

export class TimeOffStatusDeclined implements BaseStatus {
  getConfig(): StatusConfig {
    return {
      colorClasses: 'border border-red-500 text-red-500',
    };
  }
}

export class TimeOffStatusCancelled implements BaseStatus {
  getConfig(): StatusConfig {
    return {
      colorClasses: 'border border-gray-400 text-gray-400',
    };
  }
}

export class TimeOffStatusUnknown implements BaseStatus {
  getConfig(): StatusConfig {
    return {
      colorClasses: 'border border-muted-foreground text-muted-foreground',
    };
  }
}

export const createTimeOffStatus = (status: string): BaseStatus => {
  switch (status) {
    case TimeOffStatus.Approved:
      return new TimeOffStatusApproved();
    case TimeOffStatus.Pending:
      return new TimeOffStatusPending();
    case TimeOffStatus.Declined:
      return new TimeOffStatusDeclined();
    case TimeOffStatus.Cancelled:
      return new TimeOffStatusCancelled();
    default:
      return new TimeOffStatusUnknown();
  }
};

export const getTimeOffStatusText = (status: TimeOffStatus): string => {
  switch (status) {
    case TimeOffStatus.Approved:
      return i18n.t('authenticated.timeOff:status.approved');
    case TimeOffStatus.Pending:
      return i18n.t('authenticated.timeOff:status.pending');
    case TimeOffStatus.Declined:
      return i18n.t('authenticated.timeOff:status.declined');
    case TimeOffStatus.Cancelled:
      return i18n.t('authenticated.timeOff:status.cancelled');
    default:
      return i18n.t('common:unknown');
  }
};

export const getTimeOffStatusColor = (status: TimeOffStatus): string => {
  switch (status) {
    case TimeOffStatus.Approved:
      return 'emerald-500';
    case TimeOffStatus.Pending:
      return 'slate-500';
    case TimeOffStatus.Declined:
      return 'red-500';
    case TimeOffStatus.Cancelled:
      return 'gray-400';
    default:
      return 'muted-foreground';
  }
};

export const getTimeOffStatusOptions = createStatusOptionsMapper<TimeOffStatus>({
  getStatusColor: getTimeOffStatusColor,
  getStatusText: getTimeOffStatusText,
});
